// extracted by mini-css-extract-plugin
module.exports = {"award":"award-bounty_award__5hC38"};